import { render, staticRenderFns } from "./panelMoments.vue?vue&type=template&id=681f62bb&lang=pug"
import script from "./panelMoments.vue?vue&type=script&lang=js"
export * from "./panelMoments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports